var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.99799C27.9996 6.24994 27.7895 5.51698 27.3935 4.88236C26.9974 4.24774 26.4314 3.73689 25.7596 3.40782C25.0878 3.07875 24.3372 2.94465 23.5931 3.02076C22.8489 3.09686 22.141 3.38011 21.5497 3.83834C20.9585 4.29658 20.5075 4.91143 20.2482 5.61307C19.9888 6.31471 19.9314 7.07503 20.0824 7.80767C20.2334 8.54031 20.5869 9.21592 21.1026 9.75776C21.6184 10.2996 22.2757 10.686 23 10.873V12.998C23 13.2632 22.8947 13.5176 22.7071 13.7051C22.5196 13.8926 22.2652 13.998 22 13.998H10C9.73479 13.998 9.48044 13.8926 9.2929 13.7051C9.10537 13.5176 9.00001 13.2632 9.00001 12.998V10.873C9.94267 10.6296 10.7642 10.0508 11.3106 9.24498C11.857 8.4392 12.0908 7.4618 11.9681 6.49599C11.8455 5.53017 11.3747 4.64225 10.6442 3.99866C9.91374 3.35507 8.97358 3 8.00001 3C7.02644 3 6.08628 3.35507 5.35578 3.99866C4.62527 4.64225 4.15457 5.53017 4.03189 6.49599C3.90922 7.4618 4.143 8.4392 4.68941 9.24498C5.23582 10.0508 6.05735 10.6296 7.00001 10.873V12.998C7.00001 13.7936 7.31608 14.5567 7.87869 15.1193C8.4413 15.6819 9.20436 15.998 10 15.998H15H17H22C22.7957 15.998 23.5587 15.6819 24.1213 15.1193C24.6839 14.5567 25 13.7936 25 12.998V10.873C25.8583 10.65 26.6185 10.1487 27.1613 9.44748C27.7042 8.74627 27.9992 7.88479 28 6.99799Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21.1241C18.7252 21.5681 20 23.1342 20 24.998C20 27.2072 18.2091 28.998 16 28.998C13.7909 28.998 12 27.2072 12 24.998C12 23.1342 13.2748 21.5681 15 21.1241V14.998H17V21.1241Z",
    fill: "url(#paint0_linear_2533_8715)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2533_8715",
    x1: 16,
    y1: 14.998,
    x2: 16,
    y2: 28.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationIcon);
export default __webpack_public_path__ + "static/media/activationIcon.84b0fda5887a195456d36714387b59bc.svg";
export { ForwardRef as ReactComponent };